import _classCallCheck from "/var/www/html/git/naati_pte/web_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/www/html/git/naati_pte/web_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
/** A simple event emitter that can be used to listen to and emit events. */
var EventEmitter = /*#__PURE__*/function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);
    this.listeners = {};
  }
  /** Subscribe to an event. Returns an unsubscribe function. */
  _createClass(EventEmitter, [{
    key: "on",
    value: function on(eventName, listener) {
      var _this = this;
      if (!this.listeners[eventName]) {
        this.listeners[eventName] = new Set();
      }
      this.listeners[eventName].add(listener);
      return function () {
        return _this.un(eventName, listener);
      };
    }
    /** Subscribe to an event only once */
  }, {
    key: "once",
    value: function once(eventName, listener) {
      // The actual subscription
      var unsubscribe = this.on(eventName, listener);
      // Another subscription that will unsubscribe the actual subscription and itself after the first event
      var unsubscribeOnce = this.on(eventName, function () {
        unsubscribe();
        unsubscribeOnce();
      });
      return unsubscribe;
    }
    /** Unsubscribe from an event */
  }, {
    key: "un",
    value: function un(eventName, listener) {
      if (this.listeners[eventName]) {
        if (listener) {
          this.listeners[eventName].delete(listener);
        } else {
          delete this.listeners[eventName];
        }
      }
    }
    /** Clear all events */
  }, {
    key: "unAll",
    value: function unAll() {
      this.listeners = {};
    }
    /** Emit an event */
  }, {
    key: "emit",
    value: function emit(eventName) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      if (this.listeners[eventName]) {
        this.listeners[eventName].forEach(function (listener) {
          return listener.apply(void 0, args);
        });
      }
    }
  }]);
  return EventEmitter;
}();
export default EventEmitter;